import "./Maintenance.module.css";
import Header from "@/reusable_sections/Header";
import MaintenanceHero from "./sections/MaintenanceHero";
import Maintenance from "./sections/Maintenance";
import IndustryCategories from "./sections/IndustryCategories";
import Maintenancevalueproposition from "./sections/Maintenancevalueproposition";
import Emergency from "./sections/Emergency";
import Airconditioningfaq from "./sections/Airconditioningfaq";
import Maintenancecta from "./sections/Maintenancecta";
import Footer from "@/reusable_sections/Footer";
export default function MaintenancePage() {
  return <div>
      <Header />
      <MaintenanceHero />
      <Maintenance />
      <IndustryCategories />
      <Maintenancevalueproposition />
      <Emergency />
      <Airconditioningfaq />
      <Maintenancecta />
      <Footer />
    </div>;
}